import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { LABEL_CLASS, ERROR_CLASS, controlClass } from "./authFieldStyles";

// Labelled input used by the unauthenticated forms. Password fields get a
// reveal toggle; it is type="button" so AuthFormLayout's Enter handler still
// submits the form.
const AuthField = ({
  name,
  label,
  type = "text",
  placeholder,
  value,
  error,
  onChange,
  onBlur,
  required = true,
  autoComplete,
}) => {
  const [revealed, setRevealed] = useState(false);
  const isPassword = type === "password";

  return (
    <div>
      <label htmlFor={name} className={LABEL_CLASS}>
        {label} {required && <span className="text-danger-500">*</span>}
      </label>

      <div className="relative">
        <input
          type={isPassword && revealed ? "text" : type}
          name={name}
          id={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          autoComplete={autoComplete}
          className={`${controlClass(error)} ${isPassword ? "pr-11" : ""}`}
        />

        {isPassword && (
          <button
            type="button"
            tabIndex={-1}
            onClick={() => setRevealed((shown) => !shown)}
            aria-label={revealed ? "Hide password" : "Show password"}
            className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-gray-400 transition hover:text-gray-600"
          >
            {revealed ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        )}
      </div>

      {error && <p className={ERROR_CLASS}>{error}</p>}
    </div>
  );
};

export default AuthField;
